











import Vue from "vue";
import { settingName } from "@infoland/iprova-api";
import storeHelper from "../../store/store-helper";

export default Vue.extend({
    name: "PrivacyPolicy",
    props: {},
    data: function () {
        return {
            privacyPolicy: null,
            loading: false
        };
    },
    components: {},
    methods: {},
    async created() {
        this.loading = true;
        this.privacyPolicy = await storeHelper.settingsStore.getSettingAsync<string>(settingName.privacy_policy);
        this.loading = false;
    }
});
